import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconDocBlankS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1C0 0.5 0.5 0 1 0H4.13758C4.38606 0 4.51106 0 4.61794 0.0440022C4.72612 0.0885425 4.81575 0.178168 4.99609 0.358514L7.66482 3.0966C7.85962 3.2914 7.95414 3.38592 8 3.5C8.04322 3.60752 8.04322 3.73241 8.04322 3.975L8 9C8 9.5 7.5 10 7 10H1C0.5 10 0 9.5 0 9V1ZM7 3.5L4.5 1V3C4.5 3.27614 4.72386 3.5 5 3.5H6.25H7Z"
        fill="var(--color-typo-primary)"
        fillOpacity="0.3"
      />
    </svg>
  )
}
export const IconDocBlank = createIcon({
  l: IconDocBlankS,
  m: IconDocBlankS,
  s: IconDocBlankS,
  xs: IconDocBlankS,
  name: 'IconDocBlank',
})
